import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './AuditTrailTab.css';

const formatTimestamp = (timestamp) => {
  const date = new Date(timestamp);
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  });
};

const AuditTrailTab = ({ title, data }) => {
  const [auditTrail, setAuditTrail] = useState([]);

  useEffect(() => {
    if (data && data.audit_trail) {
      setAuditTrail(data.audit_trail);
    }
  }, [data]);

  return (
    <div className="audit-trail-container">
      <h2>Audit Trail for {title}</h2>
      {auditTrail.length > 0 ? (
        <div className="audit-trail-entries">
          {[...auditTrail].reverse().map((entry, index) => (


            <div key={index} className="audit-trail-entry">
              <div className="audit-trail-header">
                <span className="audit-action">{entry.Action}</span>
                <span className="audit-timestamp">{formatTimestamp(entry.Timestamp)}</span>
              </div>
              <div className="audit-user">User: {entry.User}</div>
            </div>
          ))}
        </div>
      ) : (
        <p>No audit trail entries found.</p>
      )}
    </div>
  );
};

AuditTrailTab.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
};

export default AuditTrailTab;
